import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var MOBILE_BREAKPOINT = "md";
var Wrapper = styled(Box).withConfig({
  componentId: "sc-1cdxn08-0"
})(["display:flex;flex-direction:row;align-items:center;max-width:100%;padding:", " 0;"], spacing("xxl"));
var Name = styled(Box).withConfig({
  componentId: "sc-1cdxn08-1"
})(["display:flex;flex-direction:row;align-items:center;margin-right:", ";padding:", " 0;"], spacing("xxl"), spacing("lg"));
var Content = styled(Box).withConfig({
  componentId: "sc-1cdxn08-2"
})(["flex:1 1 auto;display:flex;flex-direction:row;align-items:center;min-width:0;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint("md")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        justify-content: flex-end;\n    "])));
});
styled(Box).withConfig({
  componentId: "sc-1cdxn08-3"
})(["flex:1 1 auto;min-width:0;"]);
var Addon = styled(Box).withConfig({
  componentId: "sc-1cdxn08-4"
})(["display:flex;flex-direction:row;justify-content:flex-end;align-items:center;margin-left:auto;padding-left:", ";"], spacing("xl"));
export { Addon, Content, MOBILE_BREAKPOINT, Name, Wrapper };